/* Patient portal
   --------------------------------------------------------------------------
   The three items beside the window are a tab strip: pressing one shows that
   screen of the portal. Everything the section needs to be readable is already
   in the HTML - the first item comes out of Liquid selected and its screenshot
   visible - so this file only moves the selection, and the section degrades to
   a list and one screenshot if it never runs.

   The tab pattern is the WAI-ARIA one, which matters here because the list is
   vertical and a keyboard user reaches it as a single stop: one Tab gets into
   the strip, arrows move between the three, Tab again leaves for the button.
   Without the roving tabindex the three items would be three stops that all
   look like text.

   The window bar title is a live region rather than something we announce
   ourselves, because pressing a tab moves no focus and the picture changing is
   otherwise silent.

   Everything is wired per-section, so two of these on one page do not fight,
   and re-running is safe: Shopify re-renders a section's markup wholesale in
   the theme editor, which hands us fresh elements each time.
*/
(function () {
  'use strict';

  function setup(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ta-portal-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ta-portal-panel]'));
    var title = root.querySelector('[data-ta-portal-title]');

    /* One screen is not a choice, and Liquid has already rendered it. */
    if (tabs.length < 2 || panels.length !== tabs.length) return;

    function select(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (tab.parentElement) tab.parentElement.classList.toggle('is-active', on);
      });

      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        /* aria-hidden rather than hidden: the panels are stacked in one grid
           cell to hold the window's height, so they all have to stay laid out. */
        if (on) {
          panel.removeAttribute('aria-hidden');
        } else {
          panel.setAttribute('aria-hidden', 'true');
        }
      });

      var next = tabs[index].getAttribute('data-win-title');
      if (title && next) title.textContent = next;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i);
      });

      tab.addEventListener('keydown', function (event) {
        var last = tabs.length - 1;
        var next = null;

        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            next = i === last ? 0 : i + 1;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            next = i === 0 ? last : i - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        /* Arrows would otherwise scroll the page out from under the window. */
        event.preventDefault();
        select(next);
        tabs[next].focus();
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ta-portal]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* The theme editor replaces a section's markup on every settings change. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Picking a block in the editor's sidebar should show the screen it names,
     otherwise the merchant edits a screenshot they cannot see. */
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.querySelector('[data-ta-portal-tab]');
    if (tab) tab.click();
  });
})();
